module.exports = __webpack_public_path__ + "img/glass.ad6c9254.svg";